module.exports = __webpack_public_path__ + "img/outlander_out.a2ac13ff.jpg";